import React from "react";
import withStyles from '@mui/styles/withStyles';


import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';


import Button from '@mui/material/Button';


const styles = theme => ({

    dialogContent: {
        display: 'flex',
        flexDirection: 'column'
    }

});

const DeleteMotifResolutionDialog = ({ classes, onClose, onClickDelete, motifResolution }) => {
       
    const remove = () => {
        onClickDelete(motifResolution.id);
    };

    return (
        <Dialog open>
            <DialogTitle>Suppression d'un motif de résolution</DialogTitle>

            <DialogContent className={classes.dialogContent}>

                <p>Êtes-vous sûr de vouloir supprimer le motif de résolution : {motifResolution.libelle} / {motifResolution.code} ({motifResolution.id}) ?</p>


            </DialogContent>

            <DialogActions>
                <Button
                    onClick={onClose}
                    color="primary"
                >
                    Annuler
                </Button>
                <Button
                    onClick={remove}
                    variant="contained"
                    color="secondary"
                >
                    Supprimer
                </Button>
            </DialogActions>
        </Dialog>
    );
};


export default withStyles(styles)(DeleteMotifResolutionDialog);
